import Api from "./Api";
import Csrf from "./Csrf";

export default {
  async getLocations() {
    await Csrf.getCookie();

    return Api.get("/locations");
  },
  getLocation(id) {
    return Api.get("/locations/" + id);
  },

  getStyles() {
    return Api.get("/styles");
  },

  async createLocation(form) {
    await Csrf.getCookie();

    return Api.post("/locations/create", form);
  },

  async updateLocation(id, form) {
    await Csrf.getCookie();
    form._method = "PATCH";

    return Api.post("/locations/" + id, form);
  },

  async deleteLocation(id) {
    await Csrf.getCookie();

    return Api.post("/locations/" + id, { _method: "DELETE" });
  }
};